import { Audit } from "@/interfaces/Company";
import { Diagnosis } from "@/interfaces/Diagnosis";

/**
 * Nueva constante para trabajar con el contenido
 * posible de cada empresa, ya que, cada empresa
 * puede tener tanto auditorias como diagnosticos
 * Por esta razon se centraliza la informacion en esta constante
 * para manejar datos tanto de UI como de peticiones, rutas, etc.
 */
export const COMPANY_DATA_CONFIG = {
  audits: {
    path: "/app/audits",
    columnTableTitle: "Diagnósticos/ Auditorías",
    fetchData: "audit",
    typeData: "audits",
  },
  diagnosis: {
    path: "/app/diagnosis",
    columnTableTitle: "Diagnósticos",
    fetchData: "diagnosis",
    typeData: "diagnosis",
  },
  companies: {
    path: "/app/companies",
    columnTableTitle: "Diagnósticos",
    fetchData: "diagnosis",
    typeData: "diagnosis",
  },
} as const;

/**
 * Nuevo type creado de forma local en el modulo
 * de Companies para tipar los valores posibles
 * del contenido que puede tener una company
 * las companies puedente tener diagnosticos o
 * auditorias
 */
export type CompanyContainData = keyof typeof COMPANY_DATA_CONFIG;

/**
 * Funcion para validar si la info entrante es una auditoria
 * o es un diagnostico, esta funcion se crea para hacer un
 * rendering condicional en la vista de las empresas donde
 * se despliegan las auditorias o diagnosticos, ya que,
 * las auditorias de cada empresa pueden ser diagnosticos o
 * auditorias y se hace un rendering condicional para mostrar
 * este modo de auditorias reusando el componente CompanyData.tsx
 * @param data Object => Auditoria o Diagnostico de empresa
 * @returns Boolean => Verdadero o Falso, corrobarando el tipo entero
 */
export const isAudit = (data: Audit | Diagnosis): data is Audit => {
  return "audit_mode" in data;
};
